export const SET_CARD_NAME = (state, cardName) => {
  state.cardName = cardName;
};

export const SET_CARD_CPF = (state, cardCPF) => {
  state.cardCPF = cardCPF;
};

export const SET_CARD_NUMBER = (state, cardNumber) => {
  state.cardNumber = cardNumber;
};

export const SET_AME_ORDER_STATUS = (state, ameOrderStatus) => {
  state.ameOrderStatus = ameOrderStatus;
};

export const SET_PIX_ORDER_STATUS = (state, pixOrderStatus) => {
  state.pixOrderStatus = pixOrderStatus;
};

export const SET_CARD_DATE = (state, cardDate) => {
  state.cardDate = cardDate;
};

export const SET_PAYPAL_ORDER_TOKEN = (state, paypalToken) => {
  state.paypalToken = paypalToken;
};

export const SET_CHECK_TERMS = (state, checkTerms) => {
  state.checkTerms = checkTerms;
};

export const SET_CARD_CVC = (state, cardCVC) => {
  state.cardCVC = cardCVC;
};

export const SET_PARTIAL_ERROR = (state, partialError) => {
  state.partialError = partialError;
};

export const SET_INSTALMENT_AMOUNT = (state, instalmentAmount) => {
  state.instalmentAmount = instalmentAmount;
};

export const SET_INTEREST_AMOUNT = (state, interestAmount) => {
  state.interestAmount = interestAmount;
};

export const SET_TOTAL_AMOUNT = (state, totalAmount) => {
  state.totalAmount = totalAmount;
};

export const SET_INTERESTS = (state, interests) => {
  state.interests = interests;
};

export const SET_BILLET = (state, billet) => {
  state.billet = billet;
};

export const SET_AME = (state, ame) => {
  state.ame = ame;
};

export const SET_PIX = (state, pix) => {
  state.pix = pix;
};

export const SET_PAYPAL = (state, paypal) => {
  state.paypal = paypal;
};

export const SET_PAYPAL_PLUS = (state, paypalPlus) => {
  state.paypalPlus = paypalPlus;
};

export const SET_PAYMENT_DATA = (state, data) => {
  state.paymentData = data;
};

export const SET_PARTIAL_VALUE = (state, data) => {
  state.partialValue = data;
};

export const SET_PAYPAL_CLIENT_ID = (state, paypalClientId) => {
  state.paypalClientId = paypalClientId;
};

export const SET_OPT_IN = (state, optIn) => {
  state.optIn = optIn;
};

export const SET_INVOICE = (state, invoice) => {
  state.invoice = invoice;
};

export const SET_SECURE_3DS_OPEN = (state, value) => {
  state.secure3dsOpen = value;
};
